import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WorkflowStatusMessage } from 'interfaces-lib';
import { WorkflowTask } from 'workflow-task-service-lib';
import { Stage, StageSet, WorkflowInProgressComponent } from '../workflow-in-progress/workflow-in-progress.component';

export abstract class ProgressReportingWorkflowTask extends WorkflowTask {
  protected static readonly DEFAULT_CLOSE_DELAY_MS = 2250;
  private workflowInProgressDialogRef: MatDialogRef<WorkflowInProgressComponent>;

  protected constructor(
    workflowName: string,
    protected title: string,
    protected stages: StageSet,
    private dialog: MatDialog,
    private options?: { startStage?: string }
  ) {
    super(workflowName);
  }

  override workflowStartSuccess(): void {
    super.workflowStartSuccess();
    this.openProgress();
  }

  protected openProgress(): void {
    this.workflowInProgressDialogRef = this.dialog.open(WorkflowInProgressComponent, {
      data: {
        title: this.title,
        stages: this.stages,
      },
    });

    if (this.options?.startStage) {
      this.workflowInProgressDialogRef.componentInstance.receiveStatus(this.options.startStage);
    }
  }

  protected updateProgress(message: WorkflowStatusMessage): void {
    this.workflowInProgressDialogRef.componentInstance.receiveStatus(message.status);
  }

  protected closeProgress(delayMs?: number, closeStage?: Stage): void {
    if (this.workflowInProgressDialogRef) {
      if (closeStage) {
        this.workflowInProgressDialogRef.componentInstance.showStage(closeStage);
      }

      setTimeout(() => {
        this.workflowInProgressDialogRef.close();
      }, delayMs ?? 0);
    }
  }
}
